/**
 * Grant Navigator™ — extended compliance disclaimer, rendered inline on
 * every grant-facing user surface (Finder, Detail, Saved, Profile,
 * Readiness). Content is fixed — this is the exact copy locked in the
 * G1 dispatch.
 */
import { Info } from "lucide-react";

export const GRANT_NAVIGATOR_DISCLAIMER =
  "Grant Navigator provides educational match analysis and does not " +
  "guarantee eligibility, awards, or funding decisions. Grant sponsors " +
  "make final determinations. Match scores and eligibility snapshots " +
  "are estimates based on the information you provide.";

export default function GrantDisclaimer({ testId = "grant-navigator-disclaimer" }) {
  return (
    <div
      data-testid={testId}
      className="mt-2 rounded-xl px-3 py-2"
      style={{
        background: "rgba(167,139,250,0.06)",
        border: "1px solid rgba(167,139,250,0.18)",
      }}
    >
      <div className="flex gap-2 items-start">
        <Info className="w-3 h-3 mt-0.5 text-v2-accent flex-shrink-0" />
        <p className="text-[11px] text-v2-textMuted leading-relaxed">
          {GRANT_NAVIGATOR_DISCLAIMER}
        </p>
      </div>
    </div>
  );
}
